<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a safra <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(harvest) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_HARVEST_MUTATION,
          variables: {
            id: harvest.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyHarvest.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_HARVEST_MUTATION = gql `
  mutation($id: ID!) {
    destroyHarvest(id: $id) {
      harvest {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>